import React, { useState, useEffect, useRef } from 'react';
import '../../styles/update-toast.css';

/**
 * Non-blocking toast when a new SW version is detected.
 * Listens for CustomEvent('swUpdate') dispatched by serviceWorkerRegistration.js.
 * NO auto-reload — user must click Refresh.
 */
const UpdateToast = () => {
  const [showUpdate, setShowUpdate] = useState(false);
  const waitingWorkerRef = useRef(null);

  useEffect(() => {
    const handler = (event) => {
      if (event.detail?.registration?.waiting) {
        waitingWorkerRef.current = event.detail.registration.waiting;
        setShowUpdate(true);
      }
    };
    window.addEventListener('swUpdate', handler);
    return () => window.removeEventListener('swUpdate', handler);
  }, []);

  if (!showUpdate) return null;

  const handleRefresh = () => {
    if (waitingWorkerRef.current) {
      waitingWorkerRef.current.postMessage({ type: 'SKIP_WAITING' });
    }
    window.location.reload();
  };

  const handleDismiss = () => {
    setShowUpdate(false);
  };

  return (
    <div className="update-toast" role="alert">
      <span className="update-toast__text">New version available</span>
      <button className="update-toast__refresh" onClick={handleRefresh} type="button">
        Refresh
      </button>
      <button
        className="update-toast__dismiss"
        onClick={handleDismiss}
        type="button"
        aria-label="Dismiss"
      >
        &#x2715;
      </button>
    </div>
  );
};

export default UpdateToast;
